var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"nav-link btn btn-outline-primary",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.openRegister}},[_vm._v(_vm._s(_vm.str_accedi))]),_vm._v(" "),_c('general-login-modal'),_vm._v(" "),_c('password-recover'),_vm._v(" "),_c('password-reset',{attrs:{"token_param":_vm.token}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }